import React from 'react'
import { Dropdown } from 'react-bootstrap'
import useCurrentUser from '../../../hooks/use-current-user'
import useDiscussExperience from '../../experience/use-discuss-experience'

const ExperiencesEditMenu = ({
    experience = {},
}) => {
    const { isAdmin, isFacilitator } = useCurrentUser()
    const { showDiscussionConfiguration } = useDiscussExperience({
        experience,
        users: experience.enrollees.map(e => e.id)
    })

    return (
        <Dropdown.Item
            onClick={() => showDiscussionConfiguration()}
            disabled={!isAdmin && !isFacilitator}
        >
            Message Students
        </Dropdown.Item>
    )
}

export default ExperiencesEditMenu